// For local development, set to the full project URL e.g.
// export const API_BASE_URL = 'https://3655614-591pearfowl-stage.adobeio-static.net/api/v1/web/appbuilder-aem-storefront-prerender-ui/api'
export const API_BASE_URL = '/api/v1/web/appbuilder-aem-storefront-prerender-ui/api';
